import ViewBase from "../../../../framework/core/mvvm/view_base";
import { GameManager } from '../../../../manager/game_manager';
import AppData from "../../../public/const/app_data";
import LoaclStorage from "../../../../manager/local_storage";
import Utility from "../../../../utility/utility";


const { ccclass, property, menu } = cc._decorator;



@ccclass
@menu("package/hall/login/LoginView")
export default class LoginView extends ViewBase {

    @property(cc.Node)
    browserLoginNode: cc.Node = null;

    @property(cc.EditBox)
    editBoxAccount: cc.EditBox = null;

    @property(cc.Node)
    buttonLoginPhone: cc.Node = null;

    @property(cc.Node)
    buttonLoginFacebook: cc.Node = null;

    @property(cc.Node)
    buttonLoginLine: cc.Node = null;

    @property(cc.Node)
    buttonLoginDevice: cc.Node = null;

    @property(cc.Label)
    version: cc.Label = null;

    @property(cc.Node)
    panelTest: cc.Node = null;


    /* 服务器选择下拉框 */
    @property(cc.Node)
    dropDownItemNode: cc.Node = null;
    @property(cc.Node)
    dropDownItem1: cc.Node = null;
    @property(cc.Node)
    dropDownItem2: cc.Node = null;
    @property(cc.Node)
    dropDownItem3: cc.Node = null;
    @property(cc.Label)
    dropDownChooseLabel: cc.Label = null;


    /* 客服修复按钮 */
    @property(cc.Node)
    addBtnNode: cc.Node = null
    @property(cc.Node)
    lessBtnNode: cc.Node = null
    @property(cc.Node)
    customerBtnNode: cc.Node = null
    @property(cc.Node)
    repairBtnNode: cc.Node = null
    @property(cc.Animation)
    repairAnim: cc.Animation = null
    @property(cc.Animation)
    customerAnim: cc.Animation = null

    

    onLoad() {
        this.updateVersion();
    }

    onShow() {
        this.buttonLoginFacebook.active = Utility.version_judge(AppData.appVersion, "1.2.1")
        this.buttonLoginDevice.active = true//AppData.testMode || AppData.startCheckGame 
        this.buttonLoginPhone.active = false
    }

    updateVersion() {
        this.version.string = "v:" + GameManager.getAppAssetVersion()
    }


}
